module.exports = __webpack_public_path__ + "8d4896ec9f89aa8705e0981c4836c153.jpg";